<template>
  <div id="app">
    <template v-if="showNavBar">
      <AppBody></AppBody>
    </template>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>

<script>
import AppBody from "@/components/layout/AppBody.vue";

export default {
  components: {AppBody},
  data() {
    return {
      showNavBar: false,
    };
  },
  watch: {
    "$route.meta": function (newVal) {
      this.showNavBar = !newVal.noAppNav;
    },
  },
  computed: {},
  created() {
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./styles/reset";
@import "./styles/element-ui";
@import "./styles/variables";

#app {
  font-family: "Noto Sans SC", Helvetica, Arial, sans-serif;
  font-weight: 500;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: map-get($colors, fontColor);
  letter-spacing: 1px;

  .el-header {
    background-color: map-get($colors, primary);
    line-height: 60px;
    color: #ffffff;
    height: 60px;
    overflow: hidden;
  }

  .container2 {
    height: calc(100vh - 60px);

    .el-main {
      background-color: #e9eef3;
      color: #333;
      padding: 0 10px 10px 10px;
    }
  }
}
</style>
